import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';

const VendorDetailsCard = ({
  editPR, vendorRef, vendorSearch, setVendorSearch, setSelectedVendor,
  vendorDropdownOpen, setVendorDropdownOpen, filteredVendors, selectVendor,
  returnDate, setReturnDate, debitNoteNumber, setDebitNoteNumber,
  returnNotes, setReturnNotes,
}) => (
  <Card>
    <CardContent className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="relative" ref={vendorRef}>
          <Label className="text-xs font-semibold text-gray-600">Vendor *</Label>
          <Input value={vendorSearch}
            onChange={e => { setVendorSearch(e.target.value); setVendorDropdownOpen(!!e.target.value.trim()); if (!e.target.value) setSelectedVendor(''); }}
            placeholder="Search vendor..." className="h-9 text-sm" data-testid="pr-vendor-search"
            disabled={!!editPR}
          />
          {vendorDropdownOpen && filteredVendors.length > 0 && (
            <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {filteredVendors.map(v => (
                <div key={v.id} className="px-3 py-2 hover:bg-red-50 cursor-pointer text-sm"
                  onClick={() => selectVendor(v)} data-testid={`pr-vendor-option-${v.id}`}>
                  <span className="font-medium">{v.name}</span>
                  {v.city && <span className="text-gray-400 ml-2">({v.city})</span>}
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Return Date</Label>
          <Input type="date" value={returnDate} onChange={e => setReturnDate(e.target.value)} className="h-9 text-sm" data-testid="pr-return-date" />
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Debit Note No.</Label>
          <Input value={debitNoteNumber} onChange={e => setDebitNoteNumber(e.target.value)} placeholder="DN-2526-001" className="h-9 text-sm font-semibold text-red-700" data-testid="pr-debit-note" readOnly />
        </div>
        <div>
          <Label className="text-xs font-semibold text-gray-600">Notes</Label>
          <Input value={returnNotes} onChange={e => setReturnNotes(e.target.value)} placeholder="Return notes..." className="h-9 text-sm" data-testid="pr-notes" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default VendorDetailsCard;
